export enum ERoleName {
  Admin = 'admin',
  Member = 'member',
  Viewer = 'viewer',
  Owner = 'owner',
}

export enum EPublicRole {
  Admin = 1,
  Member = 2,
  Viewer = 3,
  Owner = 4,
}

export enum EPermissions {
  Abm = 'abm',
  Domains = 'domains',
  Leads = 'leads',
  LeadsExportsCsv = 'leads.exports.csv',
  LeadsExportsWorkflow = 'leads.exports.workflow',
  Notifications = 'notifications',
  Pages = 'pages',
  Payments = 'payments',
  ProfileActivity = 'profile.activity',
  ProfileContacts = 'profile.contacts',
  ProfileContactsReveal = 'profile.contacts.reveal',
  ProfileOverView = 'profile.overview',
  RevealApi = 'revealApi',
  Segments = 'segments',
  SettingsAccount = 'settings.account',
  SettingsCompany = 'settings.company',
  SettingsIntegrations = 'settings.integrations',
  Support = 'support',
  Tags = 'tags',
  Users = 'users',
  Workflows = 'workflows',
  Signals = 'signals',
  SettingsSecurity = 'settings.security',
  HomeScreen = 'homeScreen',
  Outreach = 'outreach',
  OutreachSender = 'outreach.sender',
}

export type Permissions = {
  [EPermissions.Abm]: boolean
  [EPermissions.Domains]: boolean
  [EPermissions.Leads]: boolean
  [EPermissions.LeadsExportsCsv]: boolean
  [EPermissions.LeadsExportsWorkflow]: boolean
  [EPermissions.Notifications]: boolean
  [EPermissions.Pages]: boolean
  [EPermissions.Payments]: boolean
  [EPermissions.ProfileActivity]: boolean
  [EPermissions.ProfileContacts]: boolean
  [EPermissions.ProfileContactsReveal]: boolean
  [EPermissions.ProfileOverView]: boolean
  [EPermissions.RevealApi]: boolean
  [EPermissions.Segments]: boolean
  [EPermissions.SettingsAccount]: boolean
  [EPermissions.SettingsCompany]: boolean
  [EPermissions.SettingsIntegrations]: boolean
  [EPermissions.Support]: boolean
  [EPermissions.Tags]: boolean
  [EPermissions.Users]: boolean
  [EPermissions.Workflows]: boolean
  [EPermissions.Signals]: boolean
  [EPermissions.SettingsSecurity]: boolean
  [EPermissions.HomeScreen]: boolean
  [EPermissions.Outreach]: boolean
  [EPermissions.OutreachSender]: boolean
}

export interface IRole {
  id: number
  name: ERoleName | string
  customer_id?: number
  permissions: Permissions

  created_at: Date
  updated_at: Date
  deleted_at: Date
}
